import { Component, NgZone } from '@angular/core';
import { SupabaseService } from "../../services/supabase.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

interface EventDetails {
  name: string;
  email: string;
  user_uuid: string;
  ip_address: string;
  device_info: string;
}

interface FileData {
  signature: {
    name: string;
    email: string;
    ip_address: string;
    user_uuid: string;
    device_info: string;
  };

  auditTrail: {
    timestamp: Date;
    event: string;
    details: EventDetails;
  }[];
}

@Component({
  selector: 'app-file-test',
  templateUrl: './file-test.component.html',
  styleUrls: ['./file-test.component.scss']
})
export class FileTestComponent {

  file: File | null = null;
  downloadUrl: SafeUrl | null = null;
  error: string | null = null;

  loading = false;

  constructor(
     private supabaseService: SupabaseService,
     private domSanitizer: DomSanitizer,
     private zone: NgZone
  ) {}

  handleFileInput(target: EventTarget) {
    this.zone.run(() => {
      this.file = (target as HTMLInputElement).files!.item(0);
    });
  }

  async testFile() {
    this.loading = true;
    try {
      const { data, error } = await this.supabaseService.supabase.auth.getSession();
      const token = data.session?.access_token;
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const timezoneOffset = -new Date().getTimezoneOffset() / 60;
      const formData = new FormData();
      formData.append("file", this.file!);
      formData.append("tz", timezone);
      formData.append("tzOffset", `${timezoneOffset}`);
      const response = await fetch('https://ftpqsrllioysqtaxrati.supabase.co/functions/v1/validate-file', {
        method: 'POST',
        body: formData,
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });
      if(response.ok) {
        const blob = await response.blob();
        await this.zone.run(async () => {
          this.file = null;
          this.downloadUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
        });
      } else {
        this.error = (await response.text() as any).replaceAll('"', '');
      }
    } catch (e) {
      console.log(e);
      this.error = "An unknown error occurred during file test";
    }

    this.loading = false;
  }

  clear() {
    this.zone.run(() => {
      this.downloadUrl = null;
      this.error = null;
      this.file = null;
    });
  }

}
